<div class="mode" [class.active]="dark">
  <app-common-svg-icons  [class]="'moon-icon'" [icons]="'moon'" (click)="layoutToggle()"></app-common-svg-icons>
  <app-common-svg-icons  [class]="'sun-icon'" [icons]="'sun'" (click)="layoutToggle()"></app-common-svg-icons>
</div>
